import React from 'react';
import { PageHero } from '../components/Sections';
import { teamMembers as fb } from '../data/mock';
import { useContent } from '../context/ContentContext';
import Seo from '../components/Seo';

const Team = () => {
  const { teamMembers = fb } = useContent();
  return (
    <div>
      <Seo
        title="Meet Our Team | Certified HVAC Technicians | Comfort Air Mechanical"
        description="Meet the friendly, certified HVAC technicians and staff at Comfort Air Mechanical, proudly serving Cortez and Southwest Colorado since 1988."
        path="/team"
      />
      <PageHero title="Meet Our Team" subtitle="Friendly, knowledgeable and certified professionals dedicated to keeping you comfortable." crumb="Team" />
      <section className="section-pad bg-white">
        <div className="container-c">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {teamMembers.map((m) => (
              <div key={m.name} className="bg-brand-bluelight rounded-2xl p-8 text-center hover-lift">
                {m.image ? (
                  <img src={m.image} alt={m.name} className="w-28 h-28 rounded-full mx-auto object-cover mb-5 shadow-lg ring-4 ring-white" />
                ) : (
                  <div className="w-28 h-28 rounded-full mx-auto bg-gradient-to-br from-brand-blue to-brand-bluedark flex items-center justify-center mb-5 shadow-lg">
                    <span className="font-display font-extrabold text-white text-2xl">{m.initials}</span>
                  </div>
                )}
                <h3 className="font-display font-bold text-xl text-brand-bluedark">{m.name}</h3>
                <div className="text-brand-green font-semibold text-sm mt-1">{m.role}</div>
                <p className="text-slate-600 text-sm mt-3 leading-relaxed">{m.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;
